import styled from 'styled-components';
import Input from '../../elements/Input';
import { MOBILE } from '../../constants';
import Button from '../../elements/Button';
var SubscribeContainer = styled.div.withConfig({
  displayName: "SubscribeFormstyles__SubscribeContainer",
  componentId: "pantheon__t2ff1q-0"
})(["align-items:center;font-family:", ";"], function (props) {
  return props.font;
});
var InputContainer = styled.div.withConfig({
  displayName: "SubscribeFormstyles__InputContainer",
  componentId: "pantheon__t2ff1q-1"
})(["display:flex;flex-direction:", ";"], function (props) {
  return props.stackedLayout ? "column" : "row";
});
var StatusText = styled.p.withConfig({
  displayName: "SubscribeFormstyles__StatusText",
  componentId: "pantheon__t2ff1q-2"
})(["color:", ";"], function (props) {
  return props.color;
});
var SubscribeInput = styled(Input).withConfig({
  displayName: "SubscribeFormstyles__SubscribeInput",
  componentId: "pantheon__t2ff1q-3"
})(["width:", ";margin-bottom:", ";@media (max-width:", "){width:", ";}"], function (props) {
  return props.stackedLayout ? "unset" : "100%";
}, function (props) {
  return props.stackedLayout ? "1rem" : "";
}, MOBILE, function (props) {
  return props.stackedLayout ? "unset" : "100%";
});
var SubscribeButton = styled(Button).withConfig({
  displayName: "SubscribeFormstyles__SubscribeButton",
  componentId: "pantheon__t2ff1q-4"
})(["display:flex;align-items:center;justify-content:center;width:16rem !important;"]);
export { SubscribeContainer, InputContainer, StatusText, SubscribeInput, SubscribeButton };